var EmailFormUSV2FlexibleContactChannelsView, EmailFormV2FlexibleContactChannelsView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormV2FlexibleContactChannelsView = require("../common/v2_flexible_contact_channels");

EmailFormUSV2FlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormUSV2FlexibleContactChannelsView, superClass);

  function EmailFormUSV2FlexibleContactChannelsView() {
    return EmailFormUSV2FlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSV2FlexibleContactChannelsView.prototype.arrangeLayoutOfIcons = function(hash, $container) {
    var contact_channel, i, len, orderedContactChannelElements, primaryContactElem, ref, ref1, ref2, ref3, secondaryContactElem, tertiaryContactElem;
    orderedContactChannelElements = [];
    if (hash.contact_channels != null) {
      ref = hash.contact_channels;
      for (i = 0, len = ref.length; i < len; i++) {
        contact_channel = ref[i];
        if ((ref1 = contact_channel.primary) != null ? ref1.channel : void 0) {
          primaryContactElem = this.addAttributesToPrimaryIcon(contact_channel.primary, $container);
          orderedContactChannelElements.push(primaryContactElem);
        }
        if ((ref2 = contact_channel.secondary) != null ? ref2.channel : void 0) {
          secondaryContactElem = this.addBloodHoundTagToIcon(contact_channel.secondary.channel, $container, "secondary");
        }
        if ((ref3 = contact_channel.tertiary) != null ? ref3.channel : void 0) {
          tertiaryContactElem = this.addBloodHoundTagToIcon(contact_channel.tertiary.channel, $container, "tertiary");
        }
      }
      this.renderIcons(orderedContactChannelElements, $container);
    }
    return $container;
  };

  EmailFormUSV2FlexibleContactChannelsView.prototype.setOrderInfo = function() {
    var order, ref, ref1;
    order = Groupon.Support.currentOrder;
    if (order) {
      return ((ref = order.deal) != null ? ref.title : void 0) || ((ref1 = order.merchant) != null ? ref1.name : void 0);
    }
  };

  EmailFormUSV2FlexibleContactChannelsView.prototype.setIssueInfo = function() {
    var ref;
    return Groupon.Support.ContentModel.getSearchInputIssue() || ((ref = Groupon.Support.ContentModel.getSubCategory()) != null ? ref.text : void 0);
  };

  EmailFormUSV2FlexibleContactChannelsView.prototype.renderLiveChat = function() {
    var ref;
    if ((ref = this.model) != null ? ref.get('liveChatExists') : void 0) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleLiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    }
  };

  return EmailFormUSV2FlexibleContactChannelsView;

})(EmailFormV2FlexibleContactChannelsView);

module.exports = EmailFormUSV2FlexibleContactChannelsView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy92Ml9mbGV4aWJsZV9jb250YWN0X2NoYW5uZWxzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2VtYWlsX2Zvcm0vVVMvdjJfZmxleGlibGVfY29udGFjdF9jaGFubmVscy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxnRkFBQTtFQUFBOzs7QUFBQSxzQ0FBQSxHQUF5QyxPQUFBLENBQVEsd0NBQVI7O0FBRW5DOzs7Ozs7O3FEQUVKLG9CQUFBLEdBQXNCLFNBQUMsSUFBRCxFQUFPLFVBQVA7QUFDcEIsUUFBQTtJQUFBLDZCQUFBLEdBQWdDO0lBQ2hDLElBQUcsNkJBQUg7QUFDRTtBQUFBLFdBQUEscUNBQUE7O1FBQ0UsbURBQTBCLENBQUUsZ0JBQTVCO1VBQ0Usa0JBQUEsR0FBcUIsSUFBQyxDQUFBLDBCQUFELENBQTRCLGVBQWUsQ0FBQyxPQUE1QyxFQUFxRCxVQUFyRDtVQUNyQiw2QkFBNkIsQ0FBQyxJQUE5QixDQUFtQyxrQkFBbkMsRUFGRjs7UUFJQSxxREFBNEIsQ0FBRSxnQkFBOUI7VUFDRSxvQkFBQSxHQUF1QixJQUFDLENBQUEsc0JBQUQsQ0FBd0IsZUFBZSxDQUFDLFNBQVMsQ0FBQyxPQUFsRCxFQUEyRCxVQUEzRCxFQUF1RSxXQUF2RSxFQUR6Qjs7UUFHQSxvREFBMkIsQ0FBRSxnQkFBN0I7VUFDRSxtQkFBQSxHQUFzQixJQUFDLENBQUEsc0JBQUQsQ0FBd0IsZUFBZSxDQUFDLFFBQVEsQ0FBQyxPQUFqRCxFQUEwRCxVQUExRCxFQUFzRSxVQUF0RSxFQUR4Qjs7QUFSRjtNQVdBLElBQUMsQ0FBQSxXQUFELENBQWEsNkJBQWIsRUFBNEMsVUFBNUMsRUFaRjs7V0FhQTtFQWZvQjs7cURBaUJ0QixZQUFBLEdBQWMsU0FBQTtBQUNaLFFBQUE7SUFBQSxLQUFBLEdBQVEsT0FBTyxDQUFDLE9BQU8sQ0FBQztJQUN4QixJQUFHLEtBQUg7OENBQ1ksQ0FBRSxlQUFaLDJDQUFtQyxDQUFFLGVBRHZDOztFQUZZOztxREFLZCxZQUFBLEdBQWMsU0FBQTtBQUNaLFFBQUE7V0FBQSxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxtQkFBN0IsQ0FBQSxDQUFBLHdFQUFtRyxDQUFFO0VBRHpGOztxREFHZCxjQUFBLEdBQWdCLFNBQUE7QUFDZCxRQUFBO0lBQUEsb0NBQVMsQ0FBRSxHQUFSLENBQVksZ0JBQVosVUFBSDtNQUNFLElBQUcsSUFBQyxDQUFBLEtBQUssQ0FBQyxHQUFQLENBQVcsMEJBQVgsQ0FBSDtRQUNFLElBQUMsQ0FBQSxRQUFRLENBQUMsY0FBVixDQUF5QjtVQUN2QixZQUFBLEVBQWMsUUFEUztVQUV2QixZQUFBLEVBQWMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxhQUFhLENBQUMsdUJBQTlCLENBQUEsQ0FGUztTQUF6QixFQURGOzthQUtBLElBQUMsQ0FBQSxRQUFRLENBQUMsY0FBVixDQUF5QjtRQUN2QixZQUFBLEVBQWMsUUFEUztRQUV2QixZQUFBLEVBQWMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxhQUFhLENBQUMsbUJBQTlCLENBQUEsQ0FGUztRQUd2QixzQkFBQSxFQUF3QixJQUFDLENBQUEsS0FBSyxDQUFDLEdBQVAsQ0FBVywwQkFBWCxDQUhEO09BQXpCLEVBTkY7O0VBRGM7Ozs7R0EzQnFDOztBQXdDdkQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
